// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footerLinks {
  padding: 0 10px;
}
.footerLinks a {
  padding: 0 10px;
  border-left: 1px solid #919aaa;
  border-left: 1px solid rgba(255, 255, 255, 0.7);
}
`, "",{"version":3,"sources":["webpack://./src/appComponents/layouts/footer/FooterLegalDocuments.less"],"names":[],"mappings":"AAAA;EACC,eAAA;AACD;AAFA;EAGE,eAAA;EAEA,8BAAA;EACA,+CAAA;AACF","sourcesContent":[".footerLinks {\n\tpadding: 0 10px;\n\ta {\n\t\tpadding: 0 10px;\n\t\t// only runs if browser cannot understand rgba. Closest approx. to 0.7 opacity of white\n\t\tborder-left: 1px solid rgb(145, 154, 170);\n\t\tborder-left: 1px solid rgba(255, 255, 255, 0.7);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
